import { render, staticRenderFns } from "./SiteLinkSection.vue?vue&type=template&id=2b17f5ab&scoped=true"
import script from "./SiteLinkSection.vue?vue&type=script&lang=ts"
export * from "./SiteLinkSection.vue?vue&type=script&lang=ts"
import style0 from "./SiteLinkSection.vue?vue&type=style&index=0&id=2b17f5ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b17f5ab",
  null
  
)

export default component.exports